// MV
$(document).ready(function ($) {
    $('.txt-anim').textillate({
        in: {
            effect: 'fadeInUp',
            delayScale: 1.5,
            delay: 80,
        }
    });
});


// ふわふわBG
$(document).ready(function ($) {
    if ($(".property__content-top").length) {
        var lastScrollTop_ptop = 0;
        var position_ptop = $(".property__content-top").position().top;

        var propertyTopVisible = false;
        //verify element is visible in viewport
        var observerPropertyTop = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                propertyTopVisible = true;
            } else {
                // console.log('not visible');
                propertyTopVisible = false;
            }
        }, { threshold: [0] });
        observerPropertyTop.observe(document.querySelector("#property-top"));

        $(window).on("scroll", function () {
            if (propertyTopVisible) {
                var st_ptop = $(this).scrollTop();

                if ($(window).width() > 800) {
                    //PC
                    if (st_ptop > lastScrollTop_ptop) {
                        // downscroll code
                        position_ptop -= 2.5;
                    } else {
                        // upscroll code
                        position_ptop += 2.5;
                    }
                    lastScrollTop_ptop = st_ptop;
                    $(".property__imgbg-top").css("transform", "translateY(" + position_ptop + "px)");
                }
                else {
                    //MOBILE
                    if (st_ptop > lastScrollTop_ptop) {
                        // downscroll code
                        position_ptop -= 0.8;
                    } else {
                        // upscroll code
                        position_ptop += 0.8;
                    }
                    lastScrollTop_ptop = st_ptop;
                    $(".property__imgbg-top").css("transform", "translateY(" + position_ptop + "px)");
                }
            } else {
                lastScrollTop_ptop = 0;
                position_ptop = $(".property__content-top").position().top;
            }
        });

    }

    if ($(".point__content").length) {
        var lastScrollTop_pt = 0;
        var position_pt = $(".point__content").position().top;

        var pointVisible = false;
        //verify element is visible in viewport
        var observerPoint = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                pointVisible = true;
            } else {
                // console.log('not visible');
                pointVisible = false;
            }
        }, { threshold: [0] });
        observerPoint.observe(document.querySelector("#point"));

        $(window).on("scroll", function () {
            if (pointVisible) {
                var st_pt = $(this).scrollTop();

                if ($(window).width() > 800) {
                    //PC
                    if (st_pt > lastScrollTop_pt) {
                        // downscroll code
                        position_pt -= 2.5;
                    } else {
                        // upscroll code
                        position_pt += 2.5;
                    }
                    lastScrollTop_pt = st_pt;
                    $(".point__imgbg").css("transform", "translateY(" + position_pt + "px)");
                }
                // else {
                //     //MOBILE
                //     if (st_ab > lastScrollTop_ab) {
                //         // downscroll code
                //         position_p -= 0.8;
                //     } else {
                //         // upscroll code
                //         position_p += 0.8;
                //     }
                //     lastScrollTop_ab = st_ab;
                //     $(".imgbg_aboutmob").css("transform", "translateY(" + position_p + "px)");
                // }
            } else {
                lastScrollTop_pt = 0;
                position_pt = $(".point__content").position().top;
            }
        });

    }

    if ($(".design__content").length) {
        var lastScrollTop_d = 0;
        var position_d = $(".design__content").position().top;

        var designVisible = false;
        //verify element is visible in viewport
        var observerDesign = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                designVisible = true;
            } else {
                // console.log('not visible');
                designVisible = false;
            }
        }, { threshold: [0] });
        observerDesign.observe(document.querySelector("#design"));

        $(window).on("scroll", function () {
            if (designVisible) {
                var st_d = $(this).scrollTop();

                if ($(window).width() > 800) {
                    //PC
                    if (st_d > lastScrollTop_d) {
                        // downscroll code
                        position_d -= 2.5;
                    } else {
                        // upscroll code
                        position_d += 2.5;
                    }
                    lastScrollTop_d = st_d;
                    $(".design__imgbg").css("transform", "translateY(" + position_d + "px)");
                }
                // else {
                //     //MOBILE
                //     if (st_ab > lastScrollTop_ab) {
                //         // downscroll code
                //         position_p -= 0.8;
                //     } else {
                //         // upscroll code
                //         position_p += 0.8;
                //     }
                //     lastScrollTop_ab = st_ab;
                //     $(".imgbg_aboutmob").css("transform", "translateY(" + position_p + "px)");
                // }
            } else {
                lastScrollTop_d = 0;
                position_d = $(".design__content").position().top;
            }
        });

    }

    if ($(".property__content-bottom").length) {
        var lastScrollTop_pbottom = 0;
        var position_pbottom = $(".property__content-bottom").position().top;

        var propertyBottomVisible = false;
        //verify element is visible in viewport
        var observerPropertyBottom = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                propertyBottomVisible = true;
            } else {
                // console.log('not visible');
                propertyBottomVisible = false;
            }
        }, { threshold: [0] });
        observerPropertyBottom.observe(document.querySelector("#property-bottom"));

        $(window).on("scroll", function () {
            if (propertyBottomVisible) {
                var st_pbottom = $(this).scrollTop();

                if ($(window).width() > 800) {
                    //PC
                    if (st_pbottom > lastScrollTop_pbottom) {
                        // downscroll code
                        position_pbottom -= 2.5;
                    } else {
                        // upscroll code
                        position_pbottom += 2.5;
                    }
                    lastScrollTop_pbottom = st_pbottom;
                    $(".property__imgbg-bottom").css("transform", "translateY(" + position_pbottom + "px)");
                }
                // else {
                //     //MOBILE
                //     if (st_ab > lastScrollTop_ab) {
                //         // downscroll code
                //         position_pbottom -= 0.8;
                //     } else {
                //         // upscroll code
                //         position_pbottom += 0.8;
                //     }
                //     lastScrollTop_ab = st_ab;
                //     $(".imgbg_aboutmob").css("transform", "translateY(" + position_pbottom + "px)");
                // }
            } else {
                lastScrollTop_pbottom = 0;
                position_pbottom = $(".property__content-bottom").position().top;
            }
        });

    }

    if ($(".about__content").length) {
        var lastScrollTop_about = 0;
        var position_about = $(".about__content").position().top;

        var aboutVisible = false;
        //verify element is visible in viewport
        var observerAbout = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                aboutVisible = true;
            } else {
                // console.log('not visible');
                aboutVisible = false;
            }
        }, { threshold: [0] });
        observerAbout.observe(document.querySelector("#about"));

        $(window).on("scroll", function () {
            if (aboutVisible) {
                var st_about = $(this).scrollTop();
                //MOBILE
                if (st_about > lastScrollTop_about) {
                    // downscroll code
                    position_about -= 0.8;
                } else {
                    // upscroll code
                    position_about += 0.8;
                }
                lastScrollTop_about = st_about;
                $(".about__imgbg").css("transform", "translateY(" + position_about + "px)");
            } else {
                lastScrollTop_about = 0;
                position_about = $(".about__content").position().top;
            }
        });

    }
});

// BG変更
$(document).ready(function ($) {

    if ($("#gallery").length) {
        var observerGallery = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                $('.top__change-bg').css("opacity", "1");
            } else {
                // console.log('not visible');
                $('.top__change-bg').css("opacity", "0");

            }
        }, { threshold: [0.2] });
        observerGallery.observe(document.querySelector("#gallery"));
    }

    if ($("#high-quality").length) {
        var observerHighQuality = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting === true) {
                // console.log('visible');
                $('.top__change-bg').css("opacity", "1");
            } else {
                // console.log('not visible');
                $('.top__change-bg').css("opacity", "0");

            }
        }, { threshold: [0.8] });
        observerHighQuality.observe(document.querySelector("#high-quality"));
    }
});

